import type { IContainer } from '../interface/container';
import {
    bindMessageInstantiator,
    injectMessageInstantiator,
    unbindMessageInstantiator,
} from './interface/instantiator';
import instantiator from './util/instantiator';

const bindJobs: Array<{
    bind: (container: IContainer) => void;
    remove: (container: IContainer) => void;
    expose: (srcContainer: IContainer, dstContainer: IContainer) => void;
}> = [
    {
        bind: (container: IContainer) =>
            bindMessageInstantiator(instantiator(container), container),
        remove: (container: IContainer) => unbindMessageInstantiator(container),
        expose: (srcContainer: IContainer, dstContainer: IContainer) =>
            bindMessageInstantiator(injectMessageInstantiator(srcContainer), dstContainer),
    },
];

const module = {
    bind: (container: IContainer) => bindJobs.forEach(binder => binder.bind(container)),
    unbind: (container: IContainer) => bindJobs.forEach(binder => binder.remove(container)),
    expose: (srcContainer: IContainer, dstContainer: IContainer) =>
        bindJobs.forEach(binder => binder.expose(srcContainer, dstContainer)),
};

export default module;
